import React, { useState } from "react";

function HelloModal() {
    const [openModal, setOpenModal] = useState(true);
    function closeModal() {
        setOpenModal(false);
    }
    return (
        <>
            {openModal ? (
                <div className='fixed z-40 bg-gray-700 bg-opacity-20  w-full h-full mt-[-5px] pt-[30px]'>
                    <div className=' absolute  z-50 flex justify-center '>
                        <div className=' relative mx-auto w-[80%] z-50 bg-white rounded-[16px] p-[10px] text-[14px]'>
                            <button
                                onClick={closeModal}
                                className='absolute right-0 px-[7px] py-[1px] mr-[10px] bg-gray-500 text-white font-bold rounded-full'>
                                X
                            </button>
                            <p className='mt-[30px]'>
                                <span className='font-[600]'>
                                    Уважаемый респондент!
                                </span>{" "}
                                Прежде всего, разрешите поблагодарить Вас за
                                уделенное время и содействие нашему
                                исследованию.{" "}
                            </p>
                            <p>
                                Наше исследование проводится в рамках
                                научно-исследовательского проекта. Полученные
                                данные будут обработаны конфиденциально и
                                использованы только в обобщенной форме в научных
                                целях. Ответы отдельных респондентов
                                публиковаться не будут. Мы гарантируем
                                анонимность анкеты. Ваше мнение очень важно для
                                нас. Отвечая на вопросы, Вы даете согласие на
                                сбор и обработку предоставленной Вами
                                информации. Опрос состоит из 22 вопросов с
                                вариантами ответов.{" "}
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
        </>
    );
}

export default HelloModal;
